import React, { useEffect, useState } from 'react'
import Buttons from '../../components/ui/button/Buttons'
import { useNavigate, useParams } from "react-router-dom";
import { useLazyGetBookingCancellationDetailsByIdQuery, useLazyRejectBookingCancelationByIdQuery } from '../../app/services/BookingCancelation/BookingCancelationListServiceApi';
import { decryptAESID } from '../../utils/Encryption';
import { useLazyGetPDFQuery } from '../../app/services/common/commonServiceApi';
import { saveAs } from "file-saver";
import ToastService from '../../services/toastService/ToastService';
import { useGenerateCreditNoteForBookingMutation } from '../../app/services/ViewIndividulaMember/ViewIndividualMemberServiceApi';
import SwalAlert from '../../services/swalService/SwalService';
import CenterModel from '../../components/ui/centerModel/CenterModel';
import PageLoader from '../../components/ui/pageLoader/PageLoader';
import { getAuditContext } from '../../lib/authenticationLibrary';

const BookingCancelationDetailsCard = () => {
    const navigate = useNavigate();
    const [getPDF, { isSuccess: isSuccessGetPDF, isLoading: isLoadingGetPDF }] = useLazyGetPDFQuery();
    const { success } = SwalAlert();
    const [openAddModalPopup, setOpenAddModalPopup] = useState(false); // Modal visibility state
    const [refundAmount, setRefundAmount] = useState(0);
    const [generateCreditNote, { isLoading: isGenerateLoading, isSuccess: isGenerateSuccess, data: responseCreditNote }] = useGenerateCreditNoteForBookingMutation()
    const [getById, { isLoading, isSuccess, data: bookingDetails }] = useLazyGetBookingCancellationDetailsByIdQuery();
    const [rejectCancellationBooking, { isLoading: isRejectLoading, isSuccess: isRejectSuccess, data: rejectResponse }] = useLazyRejectBookingCancelationByIdQuery();

    const { id } = useParams();

    useEffect(() => {
        const cancellationId = id ? decryptAESID(id, false) : 0;
        if (cancellationId > 0) {
            getById(cancellationId);
        }
    }, [id]);

    useEffect(() => {
        if (!isRejectLoading && isRejectSuccess && rejectResponse) {
            if (!rejectResponse?.hasError) {
                success("Booking Cancellation Rejected Successfully", "Success");
                navigate(-1);
            }
        }
    }, [isRejectLoading, isRejectSuccess, rejectResponse]);

    useEffect(() => {
        if (!isGenerateLoading && isGenerateSuccess && responseCreditNote) {
            ToastService.success("Credit Note Generated Successfully");
            setOpenAddModalPopup(false);
            const cancellationId = id ? decryptAESID(id, false) : 0;
            getById(cancellationId)
        }
    }, [isGenerateLoading, isGenerateSuccess, responseCreditNote]);

    const getDateTimeSessionDetails = (eventDate, eventStartTime, eventEndTime) => {
        let date = new Date(eventDate)
        // Get individual components
        const day = date.getDate();
        const month = date.toLocaleString('default', { month: 'short' });
        const year = date.getFullYear();
        const dayName = date.toLocaleString('default', { weekday: 'short' });
        return `${day} ${month} ${year} (${dayName})`;
    }

    const handleCancelBooking = () => {
        setOpenAddModalPopup(!openAddModalPopup);
    }

    const handleApproveBooking = (memberId, eventId, eventTimeSlotId, bookingId) => {
        const audit = getAuditContext();
        let request = {
            IPASMemberId: memberId || null,
            EventId: eventId || null,
            BookingId: bookingId || null,
            EventTimeSlotId: eventTimeSlotId || null,
            RefundAmount: refundAmount || 0,
            CreditNoteFilePath: null,
            CreatedAppId: audit.appId,
            CreatedBy: audit.adminUserId

        };
        generateCreditNote(request);
    };
    const onInvoiceReceiptFileDownload = async (flag, name, field) => {
        const fileName = name.split("\\").pop();
        let request = {
            type: flag,
            fileName: name,
        };
        const response = await getPDF(request);

        if (response?.data) {
            if (field === "creditNote") {
                saveAs(response?.data?.fileData, fileName);
            }
            else {
                saveAs(response.data.fileData, fileName);
            }
        } else {
            ToastService.error("Something Went Wrong");
        }
    };

    const handleRejectBooking = (cancellationId) => {
        const Audit = getAuditContext();
        let createdAppId = Audit.appId;
        let createdBy = Audit.adminUserId
        rejectCancellationBooking({cancellationId , createdAppId , createdBy});
    }

    return (
        <React.Fragment>
            {isSuccess ? <div className="container-fluid p-4" style={{ backgroundColor: "#fdf9f7" }}>
                <h3 className="mb-4">Booking Details</h3>

                <div className="card mb-4">
                    <div className="card-header  text-white" style={{ backgroundColor: '#8d010f' }}>
                        <div className="row fw-bold">
                            <div className="col">Class Name</div>
                            <div className="col">Class Date</div>
                            <div className="col">Time</div>
                            <div className="col">Session</div>
                            <div className="col">Location</div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col">{bookingDetails?.className || "-"}</div>
                            <div className="col">{getDateTimeSessionDetails(bookingDetails?.timeSlotDate) || "-"}</div>
                            <div className="col">{bookingDetails?.time}</div>
                            <div className="col">1</div>
                            <div className="col">{bookingDetails?.location || "-"}</div>
                        </div>
                    </div>
                </div>

                <div className="card mb-4">
                    <div className="card-header fw-bold">Cancellation Details</div>
                    <div className="card-body">
                        <div className="row mb-2">
                            <div className="col-md-6">
                                <strong>Reason:</strong> {bookingDetails?.reason || "N.A."}

                                {bookingDetails?.bookingCancelationFileName && <div style={{ display: "flex", alignItems: "center" }}>
                                    <strong>Cancellation file:</strong>
                                    <Buttons
                                        buttonText={`${bookingDetails?.bookingCancelationFileName}`}
                                        buttonTypeClassName="btn-link btn"
                                        disabled={!bookingDetails?.bookingCancelationFileName}
                                        onClick={() => bookingDetails?.bookingCancelationFileName && onInvoiceReceiptFileDownload("FullFilePath", bookingDetails?.bookingCancelationEncFileName)}
                                    />
                                </div>
                                }

                            </div>
                            {bookingDetails?.creditNoteFilePath && <div className="col-md-6">
                                <strong>Refund:</strong> $ {bookingDetails?.refundAmount?.toFixed(2) || "0.00"} &nbsp;
                                <Buttons
                                    onClick={() => { onInvoiceReceiptFileDownload("FullFilePath", bookingDetails?.creditNoteFilePath, "creditNote"); }}
                                    buttonText={"Download Credit Note"}
                                    buttonTypeClassName="btn-link btn "
                                    isLoading={false}
                                />
                            </div>
                            }
                        </div>
                    </div>
                </div>

                <div className="card mb-4">
                    <div className="card-header fw-bold">Booking Details</div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-6">
                                <p><strong>Booking Ref. No:</strong> {bookingDetails?.bookingReferenceNo || "N.A."}</p>
                                <p><strong>Status:</strong> {bookingDetails?.bookingStatus || "N.A."}</p>
                                <p><strong>Attendee:</strong> {bookingDetails?.attendeeName || "N.A."}</p>
                                <p><strong>Contact No:</strong> {bookingDetails?.contactNo || "N.A."}</p>
                                <p><strong>Booking Date:</strong> {getDateTimeSessionDetails(bookingDetails?.bookingDate)} </p>
                                <p><strong>Payment Type:</strong> {bookingDetails?.paymentVia || "N.A."}</p>
                                <p><strong>Payment Status:</strong> {bookingDetails?.paymentStatus || "N.A."}</p>
                            </div>
                            <div className="col-md-6">
                                <p><strong>Promo Code:</strong> {bookingDetails?.promoCode || "N.A."}</p>
                                <p><strong>Discount Price:</strong> $ {bookingDetails?.discountPrice?.toFixed(2) || "0.00"}</p>
                                <p><strong>Paid Price:</strong> $ {bookingDetails?.totalPrice?.toFixed(2) || "0.00"}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="d-flex justify-content-between align-items-center mt-4">
                    <Buttons
                        onClick={() => { navigate(-1); }}
                        buttonText={"Back"}
                        buttonTypeClassName="back-btn btn "
                        isLoading={false}
                    />
                    {bookingDetails?.bookingStatus !== "Cancelled" &&
                        <div className="d-flex justify-content-between align-items-center">
                            <Buttons
                                onClick={() => handleCancelBooking()}
                                buttonText={"Approve"}
                                buttonTypeClassName="theme-btn btn "
                                isLoading={isGenerateLoading}
                            />
                            <Buttons
                                onClick={() => { handleRejectBooking(bookingDetails?.cancellationId) }}
                                buttonText={"Reject"}
                                buttonTypeClassName="back-btn btn ml-3"
                                isLoading={isRejectLoading}
                            />

                        </div>
                    }
                </div>
                {openAddModalPopup && (
                    <CenterModel
                        modelTitle="Approve Booking Cancellation"
                        show
                        handleClose={() => handleCancelBooking()}
                    >
                        {/* <form onSubmit={() => handleApproveBooking(bookingDetails?.memberId, bookingDetails?.eventId, bookingDetails?.eventTimeSlotId, bookingDetails?.bookingId)}> */}
                        <div style={{ marginBottom: '15px' }}>
                            <label>
                                <strong>Refund Amount <span style={{ color: 'red' }}>*</span></strong>
                            </label>
                            <input
                                type="number"
                                placeholder="Please Enter Name"
                                value={refundAmount}
                                onChange={(e) => setRefundAmount(e.target.value)}
                                required
                                style={{
                                    display: 'block',
                                    width: '100%',
                                    padding: '10px',
                                    marginTop: '5px',
                                    borderRadius: '6px',
                                    border: '1px solid #ccc'
                                }}
                            />
                        </div>

                        <button
                            onClick={(e) => handleApproveBooking(bookingDetails?.memberId, bookingDetails?.eventId, bookingDetails?.eventTimeSlotId, bookingDetails?.bookingId)}
                            disabled={isGenerateLoading || !refundAmount}
                            type="submit"
                            style={{
                                backgroundColor: '#d32f2f',
                                color: 'white',
                                padding: '10px 20px',
                                border: 'none',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                fontWeight: 'bold',
                                boxShadow: '0px 4px 10px rgba(211, 47, 47, 0.3)'
                            }}
                        >
                            Submit
                        </button>
                        {/* </form> */}
                    </CenterModel>
                )}
            </div>
                : <PageLoader />}
        </React.Fragment>
    )
}

export default BookingCancelationDetailsCard